


























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";

@Component
export default class DatetimePickerComponent extends Vue {
  @Prop() rules?: any;
  @Prop() value?: string | null;
  @Prop() label?: string;
  @Prop() hideDetails?: boolean;

  datePart: string = "";
  timePart: string = "";
  isMenuOpen: boolean = false;
  mode: string = "date";

  created() {
    if (this.value) {
      this.datePart = this.value.substr(0, 10);
      this.timePart = moment(this.value).format(
        process.env.VUE_APP_CONFIGS_TIME_FORMAT
      );
    }
  }

  @Watch("timePart")
  @Watch("datePart")
  onChange() {
    console.log(this.datePart)
    if(this.timePart===""){
      this.timePart = "00:00:00"
    }
    this.$emit("input", new Date(this.datePart + " " + this.timePart || ""));
  }

  get formatedDate(): string {
    if (this.datePart)
      return (
        moment(this.datePart).format(process.env.VUE_APP_CONFIGS_DATE_FORMAT) +
        " " +
        this.timePart
      );
    return "";
  }

  openDateMenu(): void {
    this.mode = "date";
    this.isMenuOpen = true;
  }

  openTimeMenu(): void {
    this.mode = "time";
    this.isMenuOpen = true;
  }
}
